import React, { useCallback } from 'react'
import { IntegrationServiceId } from '../../../../common/integrations'
import { BaseSSOIntegrationConnector } from './BaseSSOIntegrationConnector'

interface DynamicsBasedSSOIntegrationConnectorProps {
  serviceId: IntegrationServiceId
  startConnect: boolean
  onConnected: () => void
  postConnectRedirectPath?: string
}

export const DynamicsBasedSSOIntegrationConnector: React.FC<DynamicsBasedSSOIntegrationConnectorProps> = ({
  serviceId,
  startConnect,
  onConnected,
  postConnectRedirectPath,
}) => {
  const createStateStep = `${serviceId.toLowerCase()}_discovery_step`
  return useCallback(
    () => BaseSSOIntegrationConnector({ serviceId, startConnect, onConnected, stateStep: createStateStep, postConnectRedirectPath }),
    [serviceId, startConnect, onConnected, createStateStep, postConnectRedirectPath],
  )()
}
